import React from 'react'
import gifts from '../../../assets/gifts.json'
import { Icon } from 'components/misc'
import { observer, inject } from 'mobx-react'
import { MESSAGE_TYPE_GIFT, MODES } from 'core/constants'
import { useOptions } from 'core/hooks'

const GiftSuggestion = inject('actions')(observer(({ prices, actions, conversation }) => {
  const { giftModal = {}} = actions;
  const [options] = useOptions()
  const { mode } = options

  const giftsImages = prices && Object.keys(gifts?.suggested).map(key => {
    return {
      src: gifts?.suggested[key],
      fileName: key,
      price: prices?.romantic?.[key] || 1,
    };
  })

  const handleSendGift = giftSelected => event => {
    event.preventDefault()
    conversation?.send(giftSelected?.src, MESSAGE_TYPE_GIFT);
  }

  const filteredGifts = mode !== MODES.CHAT_LIST ? giftsImages?.slice?.(0, 4) : giftsImages

  return (
    <div className="gift-suggestion-container">
      <div className="gifts-wrapper">
        {filteredGifts?.map(item => {
          const { src, price } = item
          return (
            <div key={src} className="image-container" onClick={handleSendGift(item)}>
              <div className="image-container-wrapper">
                <img src={src}/>
              </div>
              <div className="gift-price">
                {price}{' '}
                <img
                  className="gift-cost-icon"
                  src="https://images.thedatingmessenger.com/gifts/coins_icon.png"
                  width={14}
                  height={14}
                />
              </div>
            </div>
          )
        })}
      </div>
        <div className="icon-container" onClick={() => giftModal.setGiftModalState(true)}>
          <Icon
            iconName="arrowUp"
            className="chat-ui-icon_angleup"
            />
        </div>
    </div>
  )
}))

export default GiftSuggestion;
